<div id="academy-courses" class="page-layout simple">


    <div fxLayout="column" fxLayoutAlign="center">
      <div class="courses" fxLayout="row wrap" fxLayoutAlign="center" [@animateStagger]="{value:'50'}">
        <div class="mt-20" fxLayout="row" fxLayoutAlign="end center" fxFlex="100">
  <div class="" fxLayout="row" fxLayoutAlign="end center" >
          <!-- <button mat-button class="accent rndBt" fxFlex="100"
          (click)="navigateTo('/'+producto.url+'/wizard/',producto.date,producto.instituto,producto.productoID);">Crear Encuesta</button> -->
          <h2 class="pr-20">{{'FOCUS.GRUPOS.CREAR' | translate}}</h2>
          <button mat-fab color="primary" aria-label="agregaPreg" (click)="cambioTabC(); editarNombTab(2);">
          <mat-icon>add</mat-icon>

        </button>
        </div>
        </div>
  <!--cambios-->
    <ng-container >
      <ng-container *ngIf="gruposFocus">

        <mat-table [dataSource]="gruposFocus.data" class="mat-elevation-z8 " fxFlex="100">
          <!-- Position Column -->
          <ng-container matColumnDef="aplicar">
              <mat-header-cell *matHeaderCellDef>{{'FOCUS.GRUPOS.APLICAR' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let fila" class="p-10" fxLayout="row" fxLayoutAlign="start center">
                  <ng-container>
                    <mat-checkbox></mat-checkbox>

                  </ng-container>

              </mat-cell>
          </ng-container>
          <ng-container matColumnDef="nameGrupo">
            <!-- <mat-header-cell *matHeaderCellDef> Nombre del Grupo </mat-header-cell> -->
            <mat-header-cell *matHeaderCellDef>{{'FOCUS.GRUPOS.NAME' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.nombre}} </mat-cell>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="descripcion">
            <mat-header-cell *matHeaderCellDef>{{'FOCUS.GRUPOS.DESCRIPCION' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.descripcion}} </mat-cell>
          </ng-container>
          <!-- Name Column -->
          <ng-container matColumnDef="filtros">
            <mat-header-cell *matHeaderCellDef>{{'FOCUS.GRUPOS.FILTROS' | translate}}</mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.filtros}} </mat-cell>
          </ng-container>


          <ng-container matColumnDef="accion">
              <mat-header-cell *matHeaderCellDef>{{'FOCUS.GRUPOS.ACCION' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let fila" class="p-20" fxLayout="row" fxLayoutAlign="start center">
                  <ng-container>
                      <!-- <a mat-mini-fab color="primary" class="mr-20"  matTooltip="avances " href="http://counting.culturalgo.com/graphics.php" target="_blank" download>
                          <mat-icon>equalizer</mat-icon>
                      </a> -->
                      <button mat-mini-fab  class="mr-20" color="warn" (click)="deleteGruposFocus(fila._id);" matTooltip="{{'FOCUS.GRUPOS.DELETE' | translate}}">
                    <mat-icon>delete_forever</mat-icon>
                  </button>
                      <button mat-mini-fab  class="mr-20" matTooltip="{{'FOCUS.GRUPOS.EDIT' | translate}}" (click)="cambioTabC(); editarNombTab(1); infoGrupoFocusArea(fila._id);" color="warn">
                    <mat-icon>description</mat-icon>
                  </button>
                  </ng-container>

              </mat-cell>
          </ng-container>



          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>


        </mat-table>



      </ng-container>
    </ng-container>

  </div>
  <!-- / CONTENT -->

</div>
